import styles from "./DelConfirm.module.css";
interface DelConfirmProps {
    text: string;
}
const DelConfirm = (props: DelConfirmProps) => {
    return (
        <div>
            {/* <div className={styles.del_title}>{props.text} 삭제</div> */}
            <div className={styles.del_desc}>
                <p>삭제한 {props.text}는 복구할 수 없습니다.</p>
                <p>정말 삭제하시겠습니까?</p>
            </div>
        </div>
    );
};

export default DelConfirm;
